import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';
import '../styles/Navbar.css';

const Navbar = () => {
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];
  const [menuOpen, setMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <h1>bankl</h1>
        </div>
        <div className={`navbar-menu-toggle ${menuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <ul className={`navbar-menu ${menuOpen ? 'active' : ''}`}>
          <li><a href="#home" onClick={() => setMenuOpen(false)}>{t.home}</a></li>
          <li><a href="#about" onClick={() => setMenuOpen(false)}>{t.about}</a></li>
          <li><a href="#technology" onClick={() => setMenuOpen(false)}>{t.technology}</a></li>
          <li><a href="#infrastructure" onClick={() => setMenuOpen(false)}>{t.infrastructure}</a></li>
          <li><a href="#security" onClick={() => setMenuOpen(false)}>{t.security}</a></li>
          <li><a href="#roadmap" onClick={() => setMenuOpen(false)}>{t.roadmap}</a></li>
          <li><a href="#team" onClick={() => setMenuOpen(false)}>{t.team}</a></li>
          <li><button onClick={toggleLanguage} className="language-toggle">{t.language}</button></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;